import { observer } from 'mobx-react';
import { FC } from 'react';
import CustomerProfileEditStatisticsField from '../../components/CustomerProfileEditStatisticsField/CustomerProfileEditStatisticsField';
// eslint-disable-next-line
import CustomerProfileEditStatisticsFieldTitle from '../../components/CustomerProfileEditStatisticsFieldTitle/CustomerProfileEditStatisticsFieldTitle';
import { customerProfileEditStore } from '../../store';
import { formatDate } from 'src/utils/helpers';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

const CustomerProfileEditStatistics: FC = observer((): JSX.Element => {
  const { customer } = customerProfileEditStore;

  return (
    <div className="d-flex flex-column gap-30">
      <div className="d-flex flex-column">
        <Text type={TEXT.SECTION_HEADER} text="general_statistics" />

        <div className="d-flex flex-row mt-4">
          <div className="customer-profile-edit__statistic-field mr-4">
            <CustomerProfileEditStatisticsFieldTitle title="total_number_of_orders" />
            <CustomerProfileEditStatisticsField value={customer.order_total_count} />
          </div>

          <div className="d-flex flex-column gap-5">
            <CustomerProfileEditStatisticsFieldTitle title="total_revenue" />
            <CustomerProfileEditStatisticsField value={customer.order_total_sum} />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column">
        <Text type={TEXT.SECTION_HEADER} text="txt_registration_date" />

        <div className="d-flex flex-row mt-4">
          <div className="customer-profile-edit__statistic-field">
            <CustomerProfileEditStatisticsField value={formatDate(customer.created_at, {}) || '-'} />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column">
        <Text type={TEXT.SECTION_HEADER} text="first_order" />

        <div className="d-flex flex-row mt-4">
          <div className="customer-profile-edit__statistic-field">
            <CustomerProfileEditStatisticsFieldTitle title="txt_Date" />
            <CustomerProfileEditStatisticsField value={formatDate(customer.first_order?.created_at, {}) || '-'} />
          </div>

          <div className="d-flex flex-column gap-5">
            <CustomerProfileEditStatisticsFieldTitle title="order_number_1" />
            <CustomerProfileEditStatisticsField value={customer.first_order?.order_key || '-'} />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column">
        <Text type={TEXT.SECTION_HEADER} text="last_order" />

        <div className="d-flex flex-row mt-4">
          <div className="customer-profile-edit__statistic-field">
            <CustomerProfileEditStatisticsFieldTitle title="txt_Date" />
            <CustomerProfileEditStatisticsField value={formatDate(customer.last_order?.created_at, {}) || '-'} />
          </div>

          <div className="d-flex flex-column gap-5">
            <CustomerProfileEditStatisticsFieldTitle title="order_number_1" />
            <CustomerProfileEditStatisticsField value={customer.last_order?.order_key || '-'} />
          </div>
        </div>
      </div>
    </div>
  );
});

export default CustomerProfileEditStatistics;
